var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"build-badge",class:{ 'is-feature-branch': _vm.isFeatureBranch },attrs:{"aria-hidden":"true"}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }